<!-- <ngb-tabset>
    <ngb-tab>
        <ng-template ngbTabTitle>My profile</ng-template>
        <ng-template ngbTabContent> -->
            <eos-user-profile></eos-user-profile>
        <!-- </ng-template>
    </ngb-tab>
</ngb-tabset> -->